import Hero from "../Accueil/Hero.jsx";
import VioletHaloBackground from "../hook/effects/HaloViolet.jsx";
import "../Services/Services.css";
import Service1 from "../Accueil/Service1.jsx";
import Service2 from "../Accueil/Service2.jsx";
import Service3 from "../Accueil/Service3.jsx";
import Contact1 from "../Accueil/Contact1.jsx";
import Offre from "../Accueil/Offre.jsx";
import Project from "../Services/Project.jsx";
import Contact2 from "../Accueil/Contact2.jsx";
import Footer from "../general/Footer.jsx";
import AboveFooter from "../general/AboveFooter.jsx";

export default function Accueil() {
  return (
    <div className="page">
      <Hero />
      <VioletHaloBackground />
      <Service1 />
      <Contact1 />
      <Offre />
      <Project />
      <Service2 />
      <Contact2 />
      <Service3 />
      <AboveFooter />
      <Footer />
    </div>
  );
}
